import '../styling/about.css';
import profile from '../assets/profile.webp';
import DownloadCvModel from '../components/DownloadCvModal';
import { Link } from 'react-scroll';



const About = () => {
  
 

  return (
    <div id="about-section" className="about">
      <div className="about-content">
        <div className="about-text">
          <h6>About</h6>
          <h1>Let me introduce myself</h1>

          <div className="about-inner">
            <div className="about-image">
              <img src={profile} alt="Developer portrait" />
            </div>

            <div className="about-description">
              <p>
  <strong>IT Services and Technical Support</strong> with knowledge in <strong>networking</strong> (including <strong>GPON</strong>, <strong>switching</strong>, and <strong>fiber optics</strong>), and <strong>system setup</strong> (leading installations, performing <strong>software configuration</strong>, and <strong>troubleshooting</strong> diagnostics).
</p>
<p>
  Solid knowledge and skills in <strong>software development</strong>, including <strong>Laravel</strong>, <strong>Node.js</strong>, and <strong>API integrations</strong> for backend development, as well as <strong>SQL Server</strong>, <strong>MongoDB</strong>, <strong>Flutter</strong> for mobile development, and <strong>React</strong> for frontend development.
</p>

            </div>
          </div>

          <div className="about-buttons">
           
            <button className="about-btn">
              <Link
                            to="services-section"
                            smooth={window.innerWidth >= 768}
                            duration={1000} 
                    
                                 >
                            Services
                          </Link>
            </button>
         

             <DownloadCvModel />
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
